import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';

import {Paper, Dialog, DialogActions, DialogContent, DialogTitle} from '@material-ui/core'
import {Menu, MenuItem, ListItemIcon, ListItemText} from '@material-ui/core';
import {Table, TableBody, TableCell, TableHead, TableRow}  from '@material-ui/core';
import {Container, Box, IconButton} from '@material-ui/core'
import {Button, TextField } from '@material-ui/core';
//FormControl, Checkbox, InputLabel, Select, Grid
import {MoreVert} from '@material-ui/icons';
import EditIcon from '@material-ui/icons/Edit';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { EditFieldEnumDialog } from './EditFieldEnumDialog';
import { isInteger } from '../../../api/validators';


class EditFieldTemplateDialog_ extends React.Component{

    constructor(props){
        super(props)

        const {template} = this.props; 
        console.log('template')
        console.log(template)

        this.state = {
            template: template ? {...template} : {
                ID: '',
                Fields: []
            },
            errors:{
                ID: false,
                Name: false
            },
            changed: false,
            enumEditor: {
                open: false,
                fieldIndex: null,
                field: {}
            }
        }

        this.handleInput = this.handleInput.bind(this)
        this.handleFieldInput = this.handleFieldInput.bind(this)
        //this.handleAllowInput = this.handleAllowInput.bind(this)
    }

    componentDidUpdate(){
        if(this.props.template && !this.state.template){
            this.setState({template: this.props.template})
            console.log('Open field template editor dialog')
        }
    }

    handleSave(){
        if(this.validate()){

            let template =  {...this.props.template, ...this.state.template}

            //console.log('FIELD_TEMPLATE_EDITOR_SAVE')
            //console.log(template)

            this.props.onAction({type: 'FIELD_TEMPLATE_EDITOR_SAVE', template: template})
        }
    }

    handleClose(){
        if(this.state.changed){
            this.props.onAction({
                type: 'CONFIRM_DIALOG', 
                message: this.props.t('CloseFormConfirm'),
                onConfirm: ()=>{
                    this.props.onAction({type: 'FIELD_TEMPLATE_EDITOR_CLOSE'})
                }
            })
        }else{
            this.props.onAction({type: 'FIELD_TEMPLATE_EDITOR_CLOSE'})
        }
    }

    handleInput(event){
        let changed = !this.state.changed ? {changed: true} : {}
        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value
        const template = {...this.state.template}

        template[event.target.name] = val

        this.setState({template: template, ...changed})
    }

    validate(){
        const {t} = this.props

        let errors = this.state.errors;
        let error = false

        if(!this.state.template.Name){
            errors.Name = t('NameIsEmpty')
            error = true
        }else{
            errors.Name = false
        }

        this.setState({errors: errors})

        return !error;
    }

    handleFieldInput(event, index, name){
        let changed = !this.state.changed ? {changed: true} : {}

        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value
        const template = {...this.state.template}
        const fields = [...template.Fields]

        console.log({index: index, val:val, name: name} )

        const field = {...fields[index]}
        field[name] = val 
        fields[index] = field
        template.Fields = fields


        this.setState({template: template, ...changed})
    }

    handleMenuClick(event, itemID){
        this.setState({menuAnchor: event.currentTarget, menuItemID: itemID});
        event.stopPropagation();
    }

    handleMenuItemClick(action, index){
        switch(action){
            case 'FIELD_TEMPLATE_ITEM_EDITOR_DELETE':{
                let template = {...this.state.template}

                let fields = [...template.Fields]
                fields.splice(index, 1)

                template.Fields = fields

                this.setState({
                    template: template, 
                    menuAnchor: null
                })
                break
            }

            case 'FIELD_TEMPLATE_ENUM_EDITOR_OPEN':{
                let template = {...this.state.template}
                let field = template.Fields[index]
                console.log(field)
                this.setState({
                    enumEditor: {
                        open: true,
                        fieldIndex: index,
                        field: field
                    },
                    menuAnchor: null
                })
                break
            }

            case 'FIELD_TEMPLATE_ENUM_EDITOR_CLOSE':{
                this.setState({
                    enumEditor: {
                        open: false,
                        fieldIndex: null,
                        field: {}
                    }
                })
                break
            }

            default:
                this.onAction(action)
            
        }
    }

    handleMenuClose(){
        this.menuAnchor = null;
        this.setState({menuAnchor: null});
        return null;
    }


    handleMenuAddItemClick(event, type){
        if(type===undefined){
            this.setState({menuAddAnchor: event.currentTarget});
            event.stopPropagation();
        }else{
            let isEnum = type==='Enum' ? true : false
            type = type==='Enum' ? 'String' : type
            let template = {...this.state.template}
            const field = {
                Type: type,
                Name: this.getDefaultFieldName(),
                IsEnumeration: isEnum 
            }
            if(isEnum) field.Values = []

            template.Fields.push(field)

            this.setState({
                template: template, 
                menuAddAnchor: null
            })

        }
    }

    getDefaultFieldName(){

        let s = this.props.t('Field') //Field
        let j = 1

        console.log('getDefaultFieldName')
        console.log(s)
        for(var i in  this.state.template.Fields){
            console.log(i)
            console.log(this.state.template.Fields[i])

            let field = this.state.template.Fields[i]

            let s1 = field.Name.substring(0, s.length)
            let s2 = field.Name.substring(s.length)

            if(s1===s && isInteger(s2)){
                j = Math.max(j, Number(s2)+1)
            }

            console.log('s1='+s1)
            console.log('s2='+s2)
            
            //field.Name
        }

        return s + j
    }

    handleMenuAddItemClose(event){
        this.setState({menuAddAnchor: null});
        event.stopPropagation();
    }

    handleAction(action){
        switch(action.type){

            case 'FIELD_ENUM_EDITOR_CLOSE':{
                this.setState({
                    enumEditor: {
                        open: false,
                        fieldIndex: null,
                        field: {}
                    }
                })
                break
            }

            case 'FIELD_ENUM_EDITOR_SAVE':{
                const {field, fieldIndex} = action
                const template = {...this.state.template}
                const fields = [...template.Fields]

                fields[fieldIndex] = field

                template.Fields = fields

                this.setState({
                    template: template,
                    enumEditor: {
                        open: false,
                        fieldIndex: null,
                        field: {}
                    }
                })
                break
            }

            default: 
                this.props.onAction(action)
        }
    }

    render(){
        const {t} = this.props

        console.log('this.state.template');
        console.log(this.state.template);

        const title = this.props.action==='add'?t('NewTemplate'):t('EditTemplate')

        const margin = {margin:'16px 0 8px 0'}
        
        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            },
            addIcon: {
                color: 'white'
            }
        };

        //console.log('this.state.menuItemID = '+this.state.menuItemID )
        let contextItem = this.state.menuItemID ? this.state.template.Fields[this.state.menuItemID] : null
        //console.log('contextItem = '+contextItem )
        let isContextEnum = this.state.menuItemID && contextItem ? contextItem.IsEnumeration : false
        //console.log('isContextEnum = '+isContextEnum )

        return(<>
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose.bind(this)}
    aria-labelledby="edit-dialog-title">
        
    <DialogTitle id="edit-dialog-title">{title}</DialogTitle>
    <DialogContent>
        <form>
        <Container maxWidth="lg" style={{minWidth:400}}>

            <Box textAlign="center">
                <TextField name="Name"  margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.Name?this.state.errors.Name:t('Name')}
                    autoComplete="new-password"
                    error={this.state.errors.Name!==false}
                    value={this.state.template.Name}
                    onChange={this.handleInput}
                />
            </Box>


            
            <Box textAlign="center" style={{...margin, width: '100%'}}>
       
                <Paper style={{maxHeight: 250, overflow: 'auto'}}>
                <Table size="small">

                    <TableHead>
                        <TableRow>
                            <TableCell style={{...styles.head}}>{t('Type')}</TableCell>
                            <TableCell style={styles.head}>{t('Name')}</TableCell>
                            <TableCell style={{...styles.head, width:40}}>
                                    <IconButton size="small" color="primary" aria-label="more" component="span"
                                        style={styles.addIcon}
                                        onClick={(event)=>{this.handleMenuAddItemClick(event)}}>
                                        <AddCircleOutlineIcon />
                                    </IconButton>
                                </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            this.state.template.Fields.map((field, index)=>{

                                let type = field.IsEnumeration ? 'Enum':field.Type
                            //console.log('field')
                            //console.log(field)
                            return (
                            <>
                                <TableRow key={field.ID} >
                                    <TableCell>{t(type)}</TableCell>
                                    <TableCell style={{width2:50}}>
                                        <TextField name="Name"  margin="normal"
                                            hiddenLabel
                                            style={{width: '100%'}}
                                            label={this.state.errors.Name?this.state.errors.Name:''}
                                            autoComplete="new-password"
                                            error={false}
                                            value={field.Name}
                                            onChange={(event)=>this.handleFieldInput(event, index, 'Name')}
                                        />
                                    </TableCell>
                                    <TableCell style={{width:40}}>
                                        <IconButton size="small" color="inherit" aria-label="add" component="span"
                                            onClick={event=>this.handleMenuClick(event, index)}>
                                            <MoreVert />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            </>
                            
                            )

                        })
                    }
                    </TableBody>

                    <Menu anchorEl={this.state.menuAnchor} keepMounted
                        open={Boolean(this.state.menuAnchor)} onClose={this.handleMenuClose.bind(this)}>
                        <MenuItem style={{display:isContextEnum?'':'none'}} onClick={()=>{this.handleMenuItemClick('FIELD_TEMPLATE_ENUM_EDITOR_OPEN', this.state.menuItemID)}}>
                            <ListItemIcon><EditIcon/></ListItemIcon>
                            <ListItemText primary={t('EditEnum')} />
                        </MenuItem>
                        <MenuItem onClick={()=>{this.handleMenuItemClick('FIELD_TEMPLATE_ITEM_EDITOR_DELETE', this.state.menuItemID)}}>
                            <ListItemIcon><DeleteForeverIcon/></ListItemIcon>
                            <ListItemText primary={t('DeleteFieldItem')} />
                        </MenuItem>
                    </Menu>

                    <Menu anchorEl={this.state.menuAddAnchor} keepMounted
                        open={Boolean(this.state.menuAddAnchor)} onClose={this.handleMenuAddItemClose.bind(this)}>
                        <MenuItem onClick={(event)=>{this.handleMenuAddItemClick(event, 'String')}}>{t('String')}</MenuItem>
                        <MenuItem onClick={(event)=>{this.handleMenuAddItemClick(event, 'Int')}}>{t('Int')}</MenuItem>
                        <MenuItem onClick={(event)=>{this.handleMenuAddItemClick(event, 'Float')}}>{t('Float')}</MenuItem>
                        <MenuItem onClick={(event)=>{this.handleMenuAddItemClick(event, 'Date')}}>{t('Date')}</MenuItem>
                        <MenuItem onClick={(event)=>{this.handleMenuAddItemClick(event, 'Enum')}}>{t('Enum')}</MenuItem>
                    </Menu>

                </Table>
                </Paper>

            </Box>  

        </Container>
        </form>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleSave.bind(this)} variant="contained" color="primary">
            {t('Apply')}
        </Button>
        <Button onClick={this.handleClose.bind(this)} variant="contained" color="inherit">
            {t('Cancel')}
        </Button>
    </DialogActions>

</Dialog>


    {this.state.enumEditor.open ? 
        (<EditFieldEnumDialog onAction={this.handleAction.bind(this)} {...this.state.enumEditor}  />)
        : ''
    }

    </>)

    }//end render()

}

export const EditFieldTemplateDialog = withTranslation()(EditFieldTemplateDialog_);